<template>
	<div class="maskCon" v-if="isShow">
		<div class="content1">
			<dispaly-img :images="imgList" :autoplay="true" @change="ImageChange"
			  :interval="1000"
			 style="height: 50vh;"></dispaly-img>
			 
			 
		</div>
	</div>
</template>

<script>
import dispalyImg from './dispaly-Img.vue';
export default{
	components:{dispalyImg},
	data(){
		return {
			
		}
	},
	props:{
		isShow:{
			type:Boolean,
			default:false
		},
		imgList:{
			type:Array,
		}
	},
	methods:{
		ImageChange(e){
			// console.log(e)
			// return
			let len = this.imgList.length+1
			if(e==len){
				this.autoplay = false
				this.$emit('close')
			}
		}
	}
}	
</script>

<style scoped>
	.content1{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;height: 100vh;
	}
	.shell{
		position: relative;
		width: 100vw;
		height: 80vh;
		margin: 0;
		color: #fff;
		perspective: 1000px;
		transform-origin: center;
	}
	.content{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;height: 100%;
		transform-origin: center;
		transform-style: preserve-3d;
		transform: translateZ(-30vw) rotateY(0);
		animation: carousel 9s infinite cubic-bezier(0.77,0,0.175,1) forwards;
	}
	.item{
		position: absolute;width: 60vw;height: 40vw;
		background-size: cover;
	}
	.maskCon{
		position: fixed;
		top: 0;left: 0;
		right: 0;bottom: 0;
		background: rgba(0,0,0,0.5);
		z-index: 1000;
	}
	.item:nth-child(1){
		background-image: url('https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image.png');
		transform: rotateY(0) translateZ(35vw);
	}
	.item:nth-child(1){
		background-image: url('https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image1.png');
		transform: rotateY(120deg) translateZ(35vw);
	}
	.item:nth-child(1){
		background-image: url('https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image2.png');
		transform: rotateY(240deg) translateZ(35vw);
	}
	@keyframes carousel {
		0%,
		17.5%{
			transform: translateZ(-35vw) rotateY(0);
		}
		27.5%,
		45%{
			transform: translateZ(-35vw) rotateY(-120deg);
		}
		55%,
		72.5%{
			transform: translateZ(-35vw) rotateY(-240deg);
		}
		82.5%,
		100%{
			transform: translateZ(-35vw) rotateY(-360deg);
		}
	}
</style>